// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vat: GlobalValidator = createValidator("eu.vat", 70);

export default vat;
export const compact = vat.compact;
export const format = vat.format;
export const validate = vat.validate;
export const generate = (): string =>
  vat.generate?.() ??
  (() => {
    throw new Error(
      "Validator eu.vat cannot generate values",
    );
  })();
